import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightToBracket } from '@fortawesome/free-solid-svg-icons';
import { Utils } from '../../Services/Utils';
import StatusCard from './StatusCard';

const UnathorizedComponent: React.FC = () => {
    const location = useLocation();
    const returnUrl = location.state?.returnUrl ?? '/home';

    useEffect(() => {
        Utils.setDocumentTitle('401');
    }, []);

    return (
        <StatusCard
            accentColor="var(--st-danger)"
            code="401"
            title="Prístup zamietnutý"
            text="Nepodarilo sa overiť vaše oprávnenie. Prosím, prihláste sa znova."
            action={
                <Link
                    to="/"
                    state={{ returnUrl }}
                    className="st-btn st-btn--danger-fill"
                >
                    <FontAwesomeIcon icon={faArrowRightToBracket} className="st-status-action-icon" />
                    Prihlásiť sa
                </Link>
            }
        />
    );
};

export default UnathorizedComponent;
